import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { environment } from '../environments/environment';

import {
  MatDialogModule,
  MAT_DIALOG_DEFAULT_OPTIONS,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import {
  MatRadioModule,
  MAT_RADIO_DEFAULT_OPTIONS,
} from '@angular/material/radio';
import {
  MatSnackBarModule,
  MAT_SNACK_BAR_DEFAULT_OPTIONS,
} from '@angular/material/snack-bar';

import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeEnExtra from '@angular/common/locales/extra/en';
import { RouterModule } from '@angular/router';

// set locale for the application | date picker | currency pipe | etc
registerLocaleData(localeEn, 'en-ZW', localeEnExtra);

const COMPONENTS: Array<any> = [
  CommonModule,
  MatDialogModule,
  MatIconModule,
  MatProgressBarModule,
  MatRadioModule,
  MatSnackBarModule,
  RouterModule,
];

@NgModule({
  // declarations: [],
  imports: [
    ...COMPONENTS,
    // , RouterModule.forRoot(routes)
  ],
  exports: [...COMPONENTS],
  providers: [
    // { provide: MAT_BOTTOM_SHEET_DEFAULT_OPTIONS, useValue: { hasBackdrop: false } },
    // { provide: MAT_BUTTON_CONFIG, useValue: { disabledInteractive: true } },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: { hasBackdrop: false, disableClose: false },
    },
    { provide: MAT_RADIO_DEFAULT_OPTIONS, useValue: { color: 'warn' } },
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: { duration: environment.DEFAULT_SNACKBAR_TIMEOUT },
    },
  ],
  // declarations: [CompareToReceiptTypePipe],
  // bootstrap: []
})
export class AppModule {}
